import { ArrowUp, ArrowDown, Minus } from "lucide-react";

// Comparison figure in a smaller size + green/red arrow showing the trend vs today.
// `label` defaults to "yesterday" but should be the comparison day's date (e.g.
// "Wed, 28 Oct") when the previous day was a holiday — avoids implying a false trend.
export default function TrendVsYesterday({ today, yesterday, label = "yesterday", testid }) {
  if (yesterday == null) return null;
  const t = Number(String(today).replace(/,/g, "")) || 0;
  const y = Number(String(yesterday).replace(/,/g, "")) || 0;
  const Icon = t > y ? ArrowUp : t < y ? ArrowDown : Minus;
  const cls = t > y ? "text-emerald-600" : t < y ? "text-rose-600" : "text-slate-400";
  return (
    <div className={`mt-1.5 text-[11px] font-semibold flex items-center gap-1 ${cls}`} data-testid={testid}
      title={`Today: ${t.toLocaleString()} · Yesterday: ${y.toLocaleString()}`}>
      <Icon className="h-3 w-3" strokeWidth={2.75} />
      <span className="font-mono">{y.toLocaleString()}</span>
      <span className="font-normal text-slate-400">{label}</span>
    </div>
  );
}
